<template>
  <div>
    <!-- 景区详情 -->
    <!-- 编辑详情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="editTitle"
      :visible.sync="editDialogVisible"
      :before-close="edithandleClose"
      width="38%"
      center
    >
      <el-divider></el-divider>
      <el-form class="editForm" ref="form" label-width="80px" :model="defailData">
        <div class="flexDis itemInp">
          <el-form-item label="超级账号:">
            <el-input v-model="defailData.account"  disabled></el-input>
          </el-form-item>
          <el-form-item label="景区简称:">
            <span class="absPosiA" :class="btnType==1?'required':''">*</span>
            <el-input v-model="defailData.abbreviation" 
             @keyup.native="keyUp"
              @keydown.native="keydown"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="景区全称:">
          <span class="absPosiB" :class="btnType==1?'required':''">*</span>
          <el-input v-model="defailData.fullName"
          @keyup.native="keyUp"
        @keydown.native="keydown"></el-input>
        </el-form-item>
        <el-form-item label="景区描述:">
          <span class="absPosiC" :class="btnType==1?'required':''">*</span>
          <el-input type="textarea" v-model="defailData.describe"></el-input>
        </el-form-item>
        <el-form-item label="地址:">
          <span class="absPosiD" :class="btnType==1?'required':''">*</span>

          <div class="flexDis itemSele">
            <!-- 省 -->
            <el-select
              v-model="defailData.region1"
              placeholder="请选择"
              @change="provinceChange($event)"
            >
              <el-option
                v-for="(item,index) in cityProvince"
                :key="item.provinceCode"
                :label="item.provinceName"
                :value="item.provinceCode"
              ></el-option>
            </el-select>
            <!-- 市区 -->
            <el-select v-model="defailData.region2" placeholder="请选择" @change="cityChange($event)">
              <el-option
                v-for="(item,index) in cityDistrict"
                :key="item.cityCode"
                :label="item.cityName"
                :value="item.cityCode"
              ></el-option>
            </el-select>
            <!-- 县/乡 -->
            <el-select
              v-model="defailData.region3"
              placeholder="请选择"
              @change="countyChange($event)"
            >
              <el-option
                v-for="(item,index) in cityCounty"
                :key="item.countyCode"
                :label="item.countyName"
                :value="item.countyCode"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="详细地址:">
          <span class="absPosiE" :class="btnType==1?'required':''">*</span>
          <el-input v-model="defailData.infoAdress"></el-input>
        </el-form-item>
        <el-form-item label="联系人:">
          <span class="absPosiF" :class="btnType==1?'required':''">*</span>
          <el-input v-model="defailData.contacts"></el-input>
        </el-form-item>
        <div class="flexDis itemMoble">
          <el-form-item label="手机号:">
            <span class="absPosiG" :class="btnType==1?'required':''">*</span>
            <el-input v-model="defailData.mobile "></el-input>
          </el-form-item>
          <el-form-item label="Email:">
            <span class="absPosiH" :class="btnType==1?'required':''">*</span>
            <el-input v-model="defailData.email"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="状态:">
          <span class="absPosiK" :class="btnType==1?'required':''">*</span>
          <el-radio-group v-model="defailData.status">
            <el-radio label="1">上线</el-radio>
            <el-radio label="2">下线</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item class="itemBtn" v-if="btnType==2" style="margin-left:-50px">
          <el-button class="btnL" @click="editFn()">
            <i class="iconfont icon-tianxie cb"></i>编辑
          </el-button>
        </el-form-item> -->
        <!-- v-if="btnType==1"  -->
        <el-form-item class="itemBtnS" style="margin-left:-50px">
          <el-button @click="canclFn()">清空</el-button>
          <el-button class="btnL" @click="defailSureFn()">确认保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑详情弹框结束 -->
  </div>
</template>

<script>
import citySelect from "@/assets/city.json";
import {
  ScenicInfoPost,
  updateScenicPost,
  addScenicPost
} from "@/request/scenics.js";
import { Message } from 'element-ui';
export default {
  name: "scenicMangeDialog",
  props: {},
  data() {
    return {
      editDialogVisible: false, // 编辑弹框
      // 详情数据
      defailData: {
        account: "",
        abbreviation: "",
        fullName: "",
        describe: "",
        region1: "",
        region2: "",
        region3: "",
        infoAdress: "",
        contacts: "",
        mobile: "",
        email: "",
        status: "1"
      },
      // 详情传参
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      // 编辑传参
      editPar: {
        token: "",
        user_name: "",
        scenic_id: "",
        name: "",
        full_name: "",
        proid: "",
        cityid: "",
        zoneid: "",
        address: "",
        link_man: "",
        status: "",
        memo: "",
        phone: "",
        e_mail: ""
      },
      scenicId: "",
      Token: "",
      cityProvince: [],
      cityDistrict: [],
      cityCounty: [],
      editTitle: "", // 弹框标题
      btnType: "" // 详情和确认按钮区别
    };
  },
  mounted() {
    this.Token = sessionStorage.getItem("Token");
    this.cityProvince = citySelect;
  },
  methods: {
     //限制输入特殊字符
     keyUp(e) {
           e.target.value = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g,"");
          },
           // 只能输入汉字、英文、数字
        keydown(e) {
           e.target.value = e.target.value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g,"");
          },
    // 编辑弹框
    editFn() {
      this.btnType = 1;
      this.editTitle = "景区编辑";
    },
    // 选择省份
    provinceChange(e) {
      console.log(e);
      console.log(this.cityProvince);
      this.cityProvince.forEach(item => {
        if (e == item.provinceCode) {
          this.cityDistrict = item.cities;
        }
      });
      this.defailData.region2 = "";
      this.cityCounty = [];
      this.defailData.region3 = "";
    },
    // 选择市
    cityChange(e) {
      this.cityDistrict.forEach(item => {
        if (e == item.cityCode) {
          this.cityCounty = item.counties;
        }
      });
      this.defailData.region3 = "";
      // this.$forceUpdate()
    },
    // 选择县
    countyChange(e) {
      this.$forceUpdate();
    },
    // 编辑确认
    defailSureFn() {
      if (this.scenicId) {
        if( this.defailData.abbreviation==''){
          Message.error('请输入景区名称');
          return false
        }
        if( this.defailData.fullName==''){
          Message.error('请输入景区全称');
          return false
        }
        if( this.defailData.contacts==''){
          Message.error('请输入地址');

          return false
        }
        if( this.defailData.describe==''){
          Message.error('请输入景区描述');

          return false
        }
        if( this.defailData.mobile==''){
          Message.error('请输入手机号');

          return false
        }
        if( this.defailData.email==''){
          Message.error('请输入e_mail邮箱');

          return false
        }
        this.editPar = {
          token: this.Token,
          scenic_id: this.scenicId,
          name: this.defailData.abbreviation,
          full_name: this.defailData.fullName,
          proid: this.defailData.region1,
          cityid: this.defailData.region2,
          zoneid: this.defailData.region3,
          address: this.defailData.infoAdress,
          link_man: this.defailData.contacts,
          status: this.defailData.status,
          memo: this.defailData.describe,
          phone: this.defailData.mobile,
          e_mail: this.defailData.email
        };
        updateScenicPost(this.editPar).then(res => {
          if (res.data.rcode == 200) {
            Message.success(res.data.msg);
            let upData = {
              token: this.Token
            };
            this.$parent.getList(upData);
            this.editDialogVisible = false;
          } else {
            Message.error(res.data.msg);
          }
        })
      } else {
        if( this.defailData.abbreviation==''){
          Message.error('请输入景区名称');
          return false
        }
        if( this.defailData.fullName==''){
          Message.error('请输入景区全称');
          return false
        }
        if( this.defailData.contacts==''){
          Message.error('请输入地址');

          return false
        }
        if( this.defailData.describe==''){
          Message.error('请输入景区描述');
          return false
        }
        if( this.defailData.mobile==''){
          Message.error('请输入手机号');

          return false
        }
        if( this.defailData.email==''){
          Message.error('请输入e_mail邮箱');

          return false
        }
        this.editPar = {
          token: this.Token,
          // scenic_id: "",
          user_name: this.defailData.account,
          name: this.defailData.abbreviation,
          full_name: this.defailData.fullName,
          proid: this.defailData.region1,
          cityid: this.defailData.region2,
          zoneid: this.defailData.region3,
          address: this.defailData.infoAdress,
          link_man: this.defailData.contacts,
          status: this.defailData.status,
          memo: this.defailData.describe,
          phone: this.defailData.mobile,
          e_mail: this.defailData.email
        };
        addScenicPost(this.editPar).then(res => {
          if (res.data.rcode == 200) {
            Message.success(res.data.msg);
            let upData = {
              token: this.Token
            };
            this.$parent.getList(upData);
            this.editDialogVisible = false;
          } else {
            Message.error(res.data.msg);
          }
        });
      }
    },
    // 清空
    canclFn() {
      if (this.scenicId) {
        console.log("编辑");
        this.defailData = {
          account: "",
          abbreviation: "",
          fullName: "",
          describe: "",
          // city: "",
          infoAdress: "",
          contacts: "",
          mobile: "",
          email: "",
          status: "1",
          provinceList: [],
          cityList: [],
          countyList: []
        };
      } else {
        console.log("添加");
        // 初始化数据
        this.defailData = {
          account: "",
          abbreviation: "",
          fullName: "",
          describe: "",
          // city: "",
          infoAdress: "",
          contacts: "",
          mobile: "",
          email: "",
          status: "1",
          provinceList: [],
          cityList: [],
          countyList: []
        };
        this.editDialogVisible = false;
      }
    },
    // 随机超管账号
    randomLowerLetter(len) {
      const letters = "abcdefghijklmnopqrstuvwxyz";
      let res = "";
      for (let i = 0; i < len; i++) {
        var n = Math.round(Math.random() * letters.length);
        res += letters[n];
      }
      // console.log(res)
      this.defailData.account = res;
      return res;
    },

    // 详情弹框
    detail(row) {
      this.btnType = 2;
      this.editDialogVisible = true;
      if (row) {
        this.editTitle = "景区详情";
        let upData = {
          scenic_id: row.ScenicID,
          token: this.Token
        };
        this.scenicId = row.ScenicID;
        ScenicInfoPost(upData).then(res => {
          this.defailData = res.data.result;
          this.defailData = {
            account: res.data.result.user_name,
            abbreviation: res.data.result.Name,
            fullName: res.data.result.FullName,
            describe: res.data.result.memo,
            region1: String(res.data.result.ProID),
            region2: String(res.data.result.CityID),
            region3: String(res.data.result.ZoneID),
            infoAdress: res.data.result.Address,
            contacts: res.data.result.LinkMan,
            mobile: res.data.result.Phone,
            email: res.data.result.E_Mail,
            status: res.data.result.Status + ''
          };
          // 所有省份数组数据
          // 循环
          // 循环（item 和 index）
          // 接口返回了省份id,需要在说有省份数组数据内找到对应的
          // 对应的依据就是返回的id和所有数组数据内某一项的id相等
          // 相等代表可以拿到接口返回数据对应所有数组数据的下标
          // 得到下表可以进行赋值
          this.cityProvince.forEach((item, index) => {
            if (item.provinceCode == res.data.result.ProID) {
              // this.defailData.region1 = this.cityProvince[index].provinceName;
              this.cityDistrict = this.cityProvince[index].cities;
            }
          });

          this.cityDistrict.forEach((item, index) => {
            console.log(item);
            if (item.cityCode == res.data.result.CityID) {
              // this.defailData.region2 = this.cityDistrict[index].cityName;
              this.cityCounty = this.cityDistrict[index].counties;
            }
          });
          // this.cityCounty.map((item, index) => {
          //   if (item.countyCode == res.data.result.ZoneID) {
          //     this.defailData.region3 = this.cityCounty[index].countyName;
          //   }
          // });
        });
      } else {
        this.scenicId = ''
        // 初始化数据
        this.defailData = {
          account: "",
          abbreviation: "",
          fullName: "",
          describe: "",
          region1: "",
          region2: "",
          region3: "",
          infoAdress: "",
          contacts: "",
          mobile: "",
          email: "",
          status: "1",
          provinceList: [],
          cityList: [],
          countyList: []
        };
        this.editTitle = "添加景区";
        this.btnType = 1;
        this.randomLowerLetter(10);
      }
    },
    // 编辑详情关闭弹框X
    edithandleClose() {
      this.editDialogVisible = false;
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.el-form-item {
  position: relative;
}
.absPosiA {
  position: absolute;
  top: 0px;
  left: -80px;
  color: #333333;
}
.absPosiB,
.absPosiC {
  position: absolute;
  top: 0px;
  left: -80px;
  color: #333333;

}
.absPosiE {
  position: absolute;
  top: 0px;
  left: -80px;
  color: #333333;

}
.absPosiF {
  position: absolute;
  top: 0px;
  left: -65px;
  color: #333333;

}
.absPosiG {
  position: absolute;
  top: 0px;
  left: -65px;
  color: #333333;

}
.absPosiH {
  position: absolute;
  top: 0px;
  left: -60px;
  color: #333333;

}
.absPosiI {
  position: absolute;
  top: 0px;
  left: -50px;
  color: #333333;

}
.absPosiD {
  position: absolute;
  top: 0px;
  left: -50px;
  color: #333333;

}
.absPosiJ {
  position: absolute;
  top: 0px;
  left: -80px;
  color: #333333;

}
.absPosiK {
  position: absolute;
  top: 0px;
  left: -52px;
  color: #333333;

}
.editForm {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  /deep/.el-cascader {
    position: relative;
    font-size: 14px;
    line-height: 40px;
    width: 608px;
  }
  .itemBtnS {
    display: flex;
    justify-content: center;

    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
  }
  .itemBtn {
    display: flex;
    justify-content: center;

    /deep/.el-form-item__content {
      margin-left: 0px;
    }
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #246deb;
    }
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .itemSele {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    /deep/.el-select {
      width: 190px;
      height: 40px;
      margin-right: 12px;
      .el-input {
        width: 190px;
        height: 100%;
      }
    }
  }
  .itemMoble {
    width: 100%;
    display: flex;
    // flex-wrap: wrap;
    .el-form-item {
      margin-right: 50px;
    }
    /deep/.el-input {
      width: 240px;
      height: 40px;
    }
  }

  .itemInp {
    width: 100%;
    display: flex;
    // flex-wrap: wrap;
    .el-form-item {
      // display: flex;
      margin-right: 50px;
      /deep/.el-input {
        width: 240px;
        height: 40px;
        /deep/.el-input__inner {
          width: 100%;
        }
      }
    }
  }
}
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
/deep/.el-dialog{
  min-width: 400px;
}
.itemSele /deep/.el-select{
  margin-bottom: 1rem;
}
/deep/.el-dialog__title{
  color: #000 !important;
  font-family: OPPOSans !important;
  font-size: 20px !important;
  font-weight: 400 !important;
}
.required{
  color: red;
}
</style>